import {fsa, fsaError, fsaPayload} from './helpers'

export const VALIDATE_ADDRESS = 'addressValidation/validate'
/**
 * @param {Object} payload Address fields to validate
 * @param {String} payload.address1 The first line of the address
 * @param {String} payload.address2 The second line of the address
 * @param {String} payload.city The city
 * @param {String} payload.state The state
 * @param {String} payload.zip The zip code
 */
export const validateAddress = fsaPayload(VALIDATE_ADDRESS)

export const VALIDATE_ADDRESS_PENDING = 'addressValidation/pending'
export const validateAddressPending = fsa(VALIDATE_ADDRESS_PENDING)

export const VALIDATE_ADDRESS_FAILURE = 'addressValidation/failure'
export const validateAddressFailure = fsaError(VALIDATE_ADDRESS_FAILURE)

export const VALIDATE_ADDRESS_SUCCESS = 'addressValidation/success'
/**
 * @param {Object} payload
 * @param {Boolean} payload.isValid Whether UPS could find an address match
 * @param {Object} payload.recommendedUpdates Any part updates for the address
 */
export const validateAddressSuccess = fsaPayload(VALIDATE_ADDRESS_SUCCESS)

export const UTILIZE_VERIFIED_ADDRESS = 'addressValidation/utilize verified address'
export const utilizeVerifiedAddress = fsa(UTILIZE_VERIFIED_ADDRESS)

export const UTILIZE_INPUT_ADDRESS = 'addressValidation/utilize input address'
/**
 * @param {Object} payload
 * @param {Boolean} payload.bypassedVerifiedAddress Whether the user chose to bypass a recommended address update
 */
export const utilizeInputAddress = fsaPayload(UTILIZE_INPUT_ADDRESS)

export const EDIT_INPUT_ADDRESS = 'addressValidatio/edit input address'
export const editInputAddress = fsa(EDIT_INPUT_ADDRESS)
